import Reactotron from 'reactotron-react-js';
import { reactotronRedux } from 'reactotron-redux';


  const tron = Reactotron.configure({port: 3000})
    .use(reactotronRedux())
    .connect();

  tron.clear();

  console.tron = tron;
